import { getCookie } from 'typescript-cookie'

import { AUTH_TOKEN_KEY } from './constants'

export default async function (body: any): Promise<any> {
  const gqlRequest = new Request(`${process.env.REACT_APP_HASURA_URL}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getCookie(AUTH_TOKEN_KEY)}`,
    },
    body: JSON.stringify(body),
  })

  const res = await fetch(gqlRequest)

  const { data } = await res.json()

  return data
}
